import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=539ef79e"
import script from "./EventCalendar.vue?vue&type=script&lang=ts"
export * from "./EventCalendar.vue?vue&type=script&lang=ts"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&id=539ef79e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports